// @ts-nocheck
import React, { useState } from 'react';
import { useAdminToast } from './useAdminToast';

interface AdminCopyButtonProps {
  text: string;
  label?: string;
  className?: string;
  showLabel?: boolean;
}

export const AdminCopyButton: React.FC<AdminCopyButtonProps> = ({
  text,
  label,
  className = '',
  showLabel = false,
}) => {
  const [copied, setCopied] = useState(false);
  const { showSuccess } = useAdminToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      showSuccess(label ? `${label} copied to clipboard` : 'Copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`inline-flex items-center gap-1 px-2 py-1 rounded hover:bg-luna-secondary/10 transition-colors ${className}`}
      title={copied ? 'Copied!' : `Copy ${label || 'text'}`}
    >
      <span className={`material-symbols-outlined text-sm ${copied ? 'text-green-500' : 'text-luna-text-light/50 dark:text-luna-text-dark/50'}`}>
        {copied ? 'check' : 'content_copy'}
      </span>
      {showLabel && (
        <span className="text-xs text-luna-text-light/70 dark:text-luna-text-dark/70">
          {copied ? 'Copied' : 'Copy'}
        </span>
      )}
    </button>
  );
};

